var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isDisplayed)?_c('div',{staticClass:"orders-number",attrs:{"data-cy":"luck-offer-orders-number"}},[_c('v-icon',{staticClass:"icon"},[_vm._v("fas fa-users")]),_vm._v(" "+_vm._s(_vm.ordersNumber)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }